import type { CSSProperties } from 'react';

/** Exact customer colours need a theme-independent ink; a theme foreground can invert to the wrong ink. */
export const getBrandFill = (fill?: string | null): CSSProperties | undefined => {
  const hex = fill?.trim();
  if (!hex || !/^#(?:[a-f\d]{3}|[a-f\d]{6})$/i.test(hex)) return undefined;

  const rgb =
    hex.length === 4
      ? hex
          .slice(1)
          .split('')
          .map((digit) => digit.repeat(2))
          .join('')
      : hex.slice(1);
  const channels = [0, 2, 4].map((offset) => {
    const channel = parseInt(rgb.slice(offset, offset + 2), 16) / 255;
    return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  const luminance = channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
  const blackContrast = (luminance + 0.05) / 0.05;
  const whiteContrast = 1.05 / (luminance + 0.05);

  // Picking the stronger of black/white guarantees AA for every opaque sRGB fill. Some exact
  // midtone brand colours cannot reach AAA with either ink; do not silently change the brand.
  return {
    '--ds-avatar-bg': hex,
    '--ds-avatar-fg': blackContrast >= whiteContrast ? 'var(--neutral-950)' : 'var(--neutral-50)',
    '--ds-avatar-border': 'var(--border-on-surface)',
  } as CSSProperties;
};
